import { tJosa } from '@mathflat/shared/i18n/tJosa'
import * as React from 'react'

import { Icon } from '@/component/atoms/Icon'
import { openOnlineOnboardingLink } from '@/utils/openOnlineOnboardingLink'
import { mixpanelClient } from '@/utils/trackings/mixpanel'

import S from './AcademyNavLink.style'

const BUBBLE_LABEL = '영상으로 배우는 아카데미'
const BUBBLE_LABEL_SHORT = '영상 아카데미'

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick' | 'type'>

function AcademyNavLink(props: Props) {
  const menuLabel = `활용 ${tJosa('강의')}`

  const handleClick = () => {
    mixpanelClient.track('GNB_아카데미_click')
    openOnlineOnboardingLink()
  }

  return (
    <button
      type="button"
      css={S.link}
      onClick={handleClick}
      aria-label={`${menuLabel} — ${BUBBLE_LABEL}`}
      {...props}
    >
      {menuLabel}
      <Icon name="go_to_link" size={18} css={S.arrow} className="academy-link-arrow" aria-hidden />
      <span css={S.bubble} className="academy-bubble" aria-hidden>
        <span className="academy-bubble-full">{BUBBLE_LABEL}</span>
        <span className="academy-bubble-short">{BUBBLE_LABEL_SHORT}</span>
      </span>
    </button>
  )
}

export default AcademyNavLink
